import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, X, Send } from "lucide-react";

export default function LiveChat() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="live-chat-panel"
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ ease: [0.22, 1, 0.36, 1], duration: 0.35 }}
            className="mb-4 w-80 glass-strong rounded-3xl shadow-2xl shadow-black/50 overflow-hidden"
          >
            <div className="p-5 border-b border-white/10">
              <p className="font-serif text-lg text-white">North Peak Support</p>
              <p className="text-xs text-steel-light flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-green-400 inline-block" /> Online — replies in minutes
              </p>
            </div>
            <div className="p-5 space-y-3 min-h-[130px]">
              <div className="glass rounded-2xl rounded-tl-sm p-3 text-sm text-white/80 max-w-[88%]">
                👋 Hi there! How can we help you elevate your facility today?
              </div>
            </div>
            <div className="flex items-center border-t border-white/10 p-2 gap-2">
              <input
                data-testid="live-chat-input"
                placeholder="Type a message…"
                className="flex-1 text-sm px-3 py-2 bg-transparent text-white placeholder:text-white/40 focus:outline-none"
              />
              <button className="btn-pill bg-white text-ink-950 p-2.5" aria-label="Send">
                <Send className="h-4 w-4" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        data-testid="live-chat-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-label="Live chat"
        className="btn-pill h-14 w-14 bg-white text-ink-950 flex items-center justify-center shadow-xl shadow-black/40 hover:shadow-white/20"
      >
        {open ? <X /> : <MessageSquare />}
      </button>
    </div>
  );
}
